<template>
	<div>
		<div class="d-flex align-center justify-center" v-if="isVerified || loading">
			<v-chip :color="loading ? 'grey lighten-4' : 'green lighten-4'" inline>
				<v-avatar class="ml-3" size="40" :color="loading ? 'grey lighten-4' : 'green lighten-4'">
					<v-icon :color="loading ? 'grey' : 'green'">
						mdi-cellphone
					</v-icon>
				</v-avatar>
				<v-icon :color="isVerified ? 'green' : 'grey'" small class="ml-1">
					{{ loading ? 'mdi-timer-sand' : 'mdi-check' }}
				</v-icon>
				<div class="text-subtitle-1 d-flex" :class="loading ? 'grey--text' : 'green--text'">
					{{ title }}
				</div>
			</v-chip>
		</div>
		<div class="d-flex align-center justify-center" v-else>
			<div class="d-flex justify-center mt-2 align-center" style="">
				<v-text-field class="mt-0 pt-0" style="max-width: 160px;" v-model="mobileOtp" maxlength="5" label="کد تایید" :rules="[() => !!mobileOtp || 'الزامی']" required />
				<v-btn v-if="sendCodeVisible" color="success" outlined small class="mx-2 mt-1" @click="sendOTP" :loading="otpLoading">ارسال کد {{ mobile ? `(${mobile})` : '' }}</v-btn>
				<Countdown class="secondary--text fs-h3 mt-3" style="text-align: center;" @finish="countDownFinished" ref="countdown" />
				<v-btn :disabled="!canVerify" color="secondary" elevation="0" small class="mx-2 mt-1" @click="verifyOtp" :loading="verifyOtpLoading">صحت سنجی کد</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get, call } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { cloneDeep } from 'lodash'

	export default {
		name: 'MemberAuthorizationManager',
		props: {
			member: { type: Object, default: null },
			memberAuthorizationItem: { type: Object, default: null },
			userLoanRequestAuthorizationItem: { type: Object, default: null },
			area: { type: String, default: null },
		},
		components: {
			Countdown: () => import('@/components/Countdown'),
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				canVerify: false,
				verifyOtpLoading: false,
				mobileOtp: '',
				otpLoading: false,
				loading: false,
				sendCodeVisible: true,
				mobileVerified: false,
				localMemberAuthorizationItem: null
			}
		},
		computed: {
			isVerified() {
				return this.member?.mobileVerified || this.mobileVerified
			},
			color() {
				if (this.loading)
					return 'grey'
				return this.isVerified ? 'green' : 'orange'
			},
			title() {
				if (this.loading)
					return 'در حال دریافت اطلاعات...'
				return this.isVerified ? 'شماره موبایل وریفای شده است' : 'شماره موبایل وریفای نشده است'
			},
			mobile() {
				return this.member?.mobile || 'نامشخص'
			}
		},
		watch: {
			memberAuthorizationItem: {
				immediate: true,
				handler(val, oldVal) {
					this.localMemberAuthorizationItem = cloneDeep(val)
				}
			}
		},
		mounted() {
			if (!this.member?.mobileVerified)
				this.checkMobileVerified()
		},
		methods: {
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.member?.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.otpLoading = true
				api.post('account/SendOTP/' + this.member.mobile, {})
					.then(response => {
						this.canVerify = true
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.otpLoading = false
					})
			},
			verifyOtp() {
				if (!this.mobileOtp) {
					toast.error('کد تاییدیه وارد نشده است.')
					return
				}
				this.verifyOtpLoading = true
				const data = {
					memberId: this.member.id,
					memberAuthorizationItemId: this.localMemberAuthorizationItem?.id,
					userLoanRequestAuthorizationItemId: this.userLoanRequestAuthorizationItem?.id,
					otp: this.mobileOtp,
				}
				api.post(`member/${this.memberAuthorizationItem ? 'MemberAuthorizationItem' : 'UserLoanRequestAuthorizationItem'}/VerifyOtp`, data)
					.then(response => {
						this.mobileVerified = true
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.verifyOtpLoading = false
					})
			},
			checkMobileVerified() {
				this.loading = true
				api.get('member/MemberAuthorizationItem/CheckMobileVerified/' + this.member.id)
					.then(response => {
						this.mobileVerified = response
					})
					.catch(err => {
						toast.error('خطا در دریافت وضعیت وریفای بودن شماره موبایل.' + err.message)
					})
					.finally(() => {
						this.loading = false
					})
			}
		}
	}
</script>
<style scoped></style>
